import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {EventsService} from './EventsService';
import {EsriTasksService} from './esriTasks/esriTasks-service';

import { MapComponent } from './map-view/map.component';
import { MapService } from './map-view/map.service';

import { NavToolsComponent } from './tools/navTools.component';
import { AddressLocatorComponent } from './tools/addressLocator.component';
import {LocationService} from './tools/addressLocator.service';

import {BasemapNavComponent} from './tools/basemapNav.component';
import { LegendComponent } from './tools/legend.component';
import { SearchModuleComponent } from './tools/searchModule.component';
import {SearchToolComponent} from './tools/searchTool.component';
import {EmailComponent} from './tools/email.component';
import {ObliquePhotoComponent} from './tools/obliquePhoto.component';
import {ParcelReportComponent} from './tools/parcelReport.component';
import {AppHelpComponent} from './tools/apphelp.component';

import {ParcelReportService} from './tools/parcelReport.service';
import {Jsonp, Http} from '@angular/http';

@NgModule({
  imports:      [CommonModule,FormsModule,ReactiveFormsModule],
  declarations: [MapComponent, NavToolsComponent, AddressLocatorComponent, BasemapNavComponent, LegendComponent, SearchModuleComponent, SearchToolComponent, EmailComponent, ObliquePhotoComponent, ParcelReportComponent, AppHelpComponent],
  exports:      [CommonModule, FormsModule,ReactiveFormsModule, MapComponent, NavToolsComponent, AddressLocatorComponent, BasemapNavComponent, LegendComponent, SearchModuleComponent, SearchToolComponent, EmailComponent, ObliquePhotoComponent, ParcelReportComponent, AppHelpComponent]
})



export class SharedModule {
  static forRoot(): ModuleWithProviders {
    let parcelReportServiceFactory = (_esriTasksService:EsriTasksService, _mapService:MapService, _eventsService:EventsService) => {
        return () => new ParcelReportService(_esriTasksService, _mapService, _eventsService);
    };
    return {
      ngModule: SharedModule,
      providers: [MapService, EventsService, EsriTasksService, LocationService, {
          provide: ParcelReportService, 
          useFactory:parcelReportServiceFactory, 
          deps: [EsriTasksService, MapService]
      }]
    };
  }
}


// WEBPACK FOOTER //
// ./app/shared.module.ts